import Header from '@/pages/home/components/Header';
import HeroSection from '@/pages/home/components/HeroSection';
import MediaCardsGroup from '@/pages/home/components/MediaCardsGroup';
import RankingAboutGroup from '@/pages/home/components/RankingAboutGroup';
import AppTopicsGroup from '@/pages/home/components/AppTopicsGroup';
import SocialProofGroup from '@/pages/home/components/SocialProofGroup';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-800">
      <Header />
      <main>
        <HeroSection />
        <MediaCardsGroup />
        <RankingAboutGroup />
        <AppTopicsGroup />
        <SocialProofGroup />
      </main>
      <Footer />
    </div>
  );
}